import { HttpService, QueryBus, Repository, RepositoryBase, RepositorySaveResponse, TaggedUrl, Tags, Weaver } from '@skylab-shared/core';
import { NumberingModel } from '@skylab-shared/dataModel';
import { fillPlaceholders, pickBy, ResponseUtils } from '@skylab-shared/utils';
import { FlagChangeResponse } from '../common/flag-change-response';
import { NumberingBO } from './numbering.bo';


@Repository({
    boType: NumberingBO,
    apiController: TaggedUrl.join('system/numberings', [Tags.Api])
})
export class NumberingRepositoryBase extends RepositoryBase<NumberingBO, NumberingModel> {
    public constructor(
        private readonly weaver: Weaver,
        private readonly queryBus: QueryBus,
        $http: HttpService,
    ) {
        super($http);
    }

    protected createBO(): NumberingBO {
        return new NumberingBO(this.weaver, this.queryBus);
    }

    public async setAsDefaultAsync(id: number): Promise<FlagChangeResponse | void> {
        const controllerUrl = TaggedUrl.extractUrl(this.config.apiController as string);
        const url = fillPlaceholders(
            TaggedUrl.join(`${controllerUrl}/default/:id`, [Tags.Api]),
            { id: id }
        );

        try {
            const response = await this.sendRequest<any>('PUT', url);
            if (ResponseUtils.isStatusSuccess(response.status)) {
                const successData: RepositorySaveResponse = response.data;
                return {
                    value: true,
                    id: successData.object?.id,
                    version: successData.object?.version
                };
            }
        } catch (err) {
            this.logger.error(err);
        }
    }

    protected async preparePlainObjectAsync(model: NumberingModel): Promise<any> {
        return {
            id: model.id,
            active: model.active,
            name: model.name,
            version: model.version,
            default: model.default,
            used: model.documentNumberInUse,
            format: model.format,
            gapFilling: model.gapFillingMethod,
            kinds: model.kinds,
            startingNumber: model.startingNumber,
            manual: model.manual
        };
    }

    protected async fromPlainObjectAsync(item: any): Promise<NumberingModel> {
        return new NumberingModel(pickBy({
            id: item.id,
            active: item.active,
            version: item.version,
            default: item.default,
            documentNumberInUse: item.used,
            format: item.format,
            gapFillingMethod: item.gapFilling,
            name: item.name,
            kinds: item.kinds,
            startingNumber: item.startingNumber,
            manual: item.manual
        }, val => val !== void 0));
    }
}
